import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withTranslation} from 'react-i18next';
import { trackGoogleEvent } from '../../utils/googleEvents';

//TODO: ideally these should not be called here; rather, logged-in profile and image should be passed as props
import {
  getTokenRacerId,
  isLoggedIn,
} from '../../utils/isLoggedIn';
import {fetchAthlete} from '../../data/AthleteStreams';
import {AthlinksLogo} from '../../components/shared/AthlinksLogo';
import {SearchTab} from '../home/SearchTab'
import LogoFlame from '../../components/shared/AthlinksLogoFlame';
import {Link} from 'react-router-dom';
import {_header} from './styles';
import {configs} from '../../configs';
import {LiveRaceHeader} from '../../components/shared/LiveRaceHeader';
import {profileUserImageUrl} from '../../utils/profileImageUrl';
import { inIframe } from '../../utils/inIframe';
import {connectStream} from '../../lib/bastetjs/utils/connectStream';
import {colors} from '../../shared/styles';
import {Loading} from '../../components/shared/Loading';
import {
  getSearchTerm,
  setTermValue
} from '../../data/SearchTerm';
import {HeaderSearchField} from '../../components/shared/HeaderSearchField';
import {connect} from 'react-redux';
import {EVENT_CONTEXT} from '../../data/SearchContext';
import SearchFilters from './SearchFilters';
import { getSearchContext } from '../../data/allResultsStreams';

export const LoggedOutLinks = ({isMobile, t}) => {
  const currentItemStyle = (isMobile) ? _header.menuItemMobile : _header.navButton;
  const linkProps = inIframe() ? { target: '_blank' } : {};

  return (
    <div style={_header.actionContainer(isMobile)} className="header-links">
    {isMobile
      ? <Link to='/' id="homepage-link" style={currentItemStyle(false)}>{t('Home')}</Link>
      : null
    }
      <a style={currentItemStyle(false)}
        id="sign-in"
        onClick={() => trackGoogleEvent('Authentication', 'Click', 'Sign In')}
        href={window.kc.createLoginUrl()}
        {...linkProps}
        >
          {t('Sign In')}
      </a>
      <a style={currentItemStyle(true)} id="signup-link"
        onClick={() => trackGoogleEvent('Authentication', 'Click', 'Sign Up')}
        href={window.kc.createRegisterUrl()}
        {...linkProps}
        >
          {t('Sign Up')}
      </a>
    </div>
  )
};


class LoggedInLinksComponent extends Component {
  static propTypes = {
    isMobile: PropTypes.bool,
    t: PropTypes.func
  };

  state = {
    popupVisible: false,
    showLoader: false
  };

  componentDidMount() {
    if(getTokenRacerId()) {
      fetchAthlete(getTokenRacerId());
    }
  }

  handleClick = () => {
    if (!this.state.popupVisible) {
      // attach/remove event handler
      document.addEventListener('click', this.handleOutsideClick, false);
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }

    this.setState((prevState) => ({
      popupVisible: !prevState.popupVisible,
    }));
  };

  handleOutsideClick = (e) => {
    // ignore clicks on the component itself
    if (this.node && this.node.contains(e.target)) {
      return;
    }

    this.handleClick();
  };

  render() {
    const {
      isMobile,
      t
    } = this.props;

    const {
      popupVisible,
      showLoader
    } = this.state;

    const loggedInId = getTokenRacerId();
    const profPicUrl = loggedInId ? profileUserImageUrl(loggedInId) : null;

    if(showLoader) {
      return (
        <div className="popover-container" ref={(node) => { this.node = node; }} style={ _header.actionContainer(isMobile) }>
          {isMobile &&
          <div style={{height: 129}}>
            <Loading timeoutMessage={t('Still thinking...')}/>
          </div>
          }
          { profPicUrl && !isMobile &&
            <div style={_header.profPicContainer}>
              <img
                onClick={this.handleClick}
                style={_header.profPicIMG}
                src={profPicUrl}
              />
              <div className="popover" style={Object.assign({}, _header.dropMenu(true), {height: 126})}>
                <Loading timeoutMessage={t('Still thinking...')}/>
              </div>
            </div>
          }
        </div>
      );
    }

    return (
      <div className="popover-container" ref={(node) => { this.node = node; }} style={ _header.actionContainer(isMobile) }>

        {isMobile &&
          <div id="menu-items">
            <Link
              to={`/athletes/${loggedInId}`}
              style={_header.menuItemMobile(false)}
              >
              {t('Profile')}
            </Link>
            <a
              href={`${configs.keycloakUrl}/auth/realms/athlinks/account/#edit-profile`}
              style={_header.menuItemMobile(false)}
              target="account-settings"
            >
              {t('Settings')}
            </a>
            <a
              href={window.kc.createLogoutUrl()}
              style={_header.menuItemMobile(false)}
            >
              {t('Sign Out')}
            </a>
          </div>
        }
        { profPicUrl && !isMobile &&
        <div style={_header.profPicContainer} id="menu-items">
          <img
            onClick={this.handleClick}
            style={_header.profPicIMG}
            src={profPicUrl}
          />
          { this.state.popupVisible && (
            <div id="menu-popover" className="popover" style={_header.dropMenu(popupVisible)}>
              <Link
                id="athlete-profile-link"
                to={`/athletes/${loggedInId}`}
                style={_header.dropMenuItem}>
                {t('Profile')}
              </Link>
              <a
                id="edit-profile"
                href={window.kc.createAccountUrl()}
                style={_header.dropMenuItem}
              >
                {t('Settings')}
              </a>
              <a
                id="sign-out-link"
                href={window.kc.createLogoutUrl()}
                style={_header.dropMenuItem}>
                {t('Sign Out')}
              </a>
            </div>
          )}
        </div>
        }
      </div>
    );
  }
}

export const LoggedInLinks = withTranslation()(LoggedInLinksComponent);

const setSearchTermInStream = ({target: {value}}) => {
  setTermValue(value);
};

const mapStateToPropsHeader = (state) => ({
  context: state.search.context
});

class HomePageHeaderComponent extends Component {
  render() {
    const {
      athlete,
      context,
      filters,
      hasLiveBanner,
      history,
      isMobile,
      liveEventURL,
      onSearchInput,
      searchTab,
      searchTerm,
      showHeaderFilters,
      showSearchBar,
      t,
      unifiedSearchMode
    } = this.props;

    const browserName = bowser.name.toLowerCase();
    const link = _header.logoLink(browserName === 'internet explorer');
    const navLeft = (browserName === 'internet explorer') ? _header.navLeftIE : _header.navLeft;
    const url = isLoggedIn() ? `/athletes/${getTokenRacerId()}` : '/';
    const placeholderText = context === EVENT_CONTEXT ? t('Enter an event name') : t('Enter an athlete name');

    const onSearchChange = onSearchInput || setSearchTermInStream;

    return (
      <div>
        <nav style={_header.navContainer(showSearchBar)}>
          <div style={_header.topNav}>
            {
              // Left logo
            }
            <div style={navLeft}>
              <Link
                id='athlinks-logo'
                to={url}
                style={link}
              >
                {!showSearchBar ?
                  <AthlinksLogo fill={colors.white} showFullLogo={true}/> :
                  !isMobile ?
                    <AthlinksLogo fill={colors.white} showFullLogo={true}/> :
                    <LogoFlame fill={colors.blue}/>
                }
              </Link>
            </div>
            {
              // Search Input
            }
            <div style={ _header.navCenter(isLoggedIn()) }>
              <div style={{display: 'flex'}}>
              {
                showSearchBar &&
                <SearchTab
                  styleMode={'dark'}
                  isMobile={isMobile}
                  searchTerm={searchTerm}
                />
              }
              {
                showSearchBar &&
                <div style={{flex: '1 1 100%'}}>
                  <HeaderSearchField
                    id="header"
                    type='search'
                    placeholder={placeholderText}
                    onChange={onSearchChange}
                    isMobile={isMobile}
                    value={searchTerm}
                    context={context}
                    unifiedSearchMode={unifiedSearchMode}
                    style={_header.headerSearchField(showSearchBar)}
                  />
                </div>
              }
              </div>
            </div>

            {
              // Right-side links
            }
            <div style={_header.navRight}>
              {
                isLoggedIn() ?
                  <LoggedInLinks showSearchBar={showSearchBar}/> :
                  <LoggedOutLinks showSearchBar={showSearchBar} isMobile={isMobile} t={t}/>
              }
            </div>
          </div>
        </nav>
        {
          showHeaderFilters &&
          <nav style={ _header.filterNavContainer(showSearchBar) }>
            <SearchFilters activeContext={searchTab} filters={filters} history={history}/>
          </nav>
        }
        {
          hasLiveBanner &&
          <LiveRaceHeader
            isMobile={isMobile}
            liveEventURL={liveEventURL}
            isProfile={true}
            athlete={athlete}
            t={t}
          />
        }
      </div>
    );
  }
}

export const HomePageHeader = connect(mapStateToPropsHeader)(withTranslation()(
  connectStream({
    context: getSearchContext,
    searchTerm: getSearchTerm
  })(HomePageHeaderComponent)));



/** WEBPACK FOOTER **
 ** ./views/home/HomePageHeader.js
 **/